module.exports = __webpack_public_path__ + "static/bg-hero-gradient-ae3f70651294980caf7b1a2a97d1d8c9.png";